export const SET_PAGE_LANGUAGE = 'SET_PAGE_LANGUAGE';
export const SET_MASTERDATA = 'SET_MASTERDATA';